import { Component } from '@angular/core';

@Component({
  selector: 'areas-page',
  templateUrl: './areas.component.html',
  styleUrls: ['./areas.component.less']
})
export class AreasPageComponent {

  constructor() { }

}



// WEBPACK FOOTER //
// D:/dclean-web-latest/cot-web/src/app/pages/areas/areas.component.ts